import React, { useState } from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { useMutation, useQuery } from 'react-query';
import { CredusButton, CredusSelect, CredusText, OptionType } from 'ui';

import { InfoIcon } from '../../../../../assets/images/svgs';
import testApi from '../../../../../api/test';
import userGroupIcon from '../../../../../assets/images/png/Ellipse 54.png';
import { Period } from '../../../../../api/test';

interface TestUploadSuccessProps {
  assignUser: boolean;
  testId: number;
  testIds: number[];
  isBatchAssign: boolean;
  setAssignUser: React.Dispatch<React.SetStateAction<boolean>>;
  setShowActionSuccess: React.Dispatch<React.SetStateAction<boolean>>;
}

const AssignUserModal = ({
  assignUser,
  testId,
  testIds,
  setShowActionSuccess,
  isBatchAssign,
  setAssignUser,
}: TestUploadSuccessProps) => {
  const [loading, setLoading] = useState(false);
  const [periodId, setPeriodId] = useState(0);
  const { data: periodData } = useQuery(['testPeriods', 1], () =>
    testApi.getTestPeriod(1)
  );

  const period = periodData?.data?.map((el: Period) => ({
    optionName: (
      <OptionDiv>
        <img src={userGroupIcon} />
        <TextDiv>
          <CredusText size="md">{el.period}</CredusText>
          <CredusText size="xs">Group. 20 Members</CredusText>
        </TextDiv>
      </OptionDiv>
    ),
    optionValue: el.period,
    optionId: el.periodId,
  }));

  const { mutate } = useMutation(testApi.assignTest, {
    onMutate: () => setLoading(true),
    onSuccess: () => {
      setLoading(false);
      setAssignUser(false);
      setShowActionSuccess(true);
    },
    onError: (error) => {
      setLoading(false);
      throw error;
    },
  });
  const handleCancel = () => {
    setAssignUser(false);
  };
  const handleClick = () => {
    if (isBatchAssign) {
      if (testIds) mutate({ testIds, periodId });
    } else {
      if (testId) mutate({ testIds: [testId], periodId });
    }
  };

  const handlePeriod = (id: number) => {
    setPeriodId(id);
  };

  return (
    <Modal
      title={
        <CredusText size="md" weight="medium">
          Assign User
        </CredusText>
      }
      open={assignUser}
      footer=""
      onCancel={handleCancel}
    >
      <Container>
        <CredusSelect
          options={period}
          variant="medium"
          label="select user or group"
          onChange={(value) =>
            handlePeriod(
              period?.filter((el: OptionType) => el.optionValue == value)[0]
                ?.optionId
            )
          }
        />
        <SubText>
          <InfoIcon />
          <CredusText color="#000929" size="xs">
            select the group of user you want to assign the test to
          </CredusText>
        </SubText>
        <BtnDiv>
          <CredusButton variant="secondary" onClick={handleCancel}>
            Return
          </CredusButton>
          <CredusButton onClick={handleClick} disabled={loading}>
            {loading ? 'Loading' : 'Confirm'}
          </CredusButton>
        </BtnDiv>
      </Container>
    </Modal>
  );
};

export default AssignUserModal;

const Container = styled.div`
  padding: 2rem;
  width: 100%;
`;

const BtnDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 4rem;
`;

const SubText = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

const OptionDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const TextDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;
